import { capitalize } from 'lodash';

import type {
  SliderDynamicAttributes,
  SublinesAttributes,
} from 'hb-builder/components/BuilderComponents/dynamic/Slider/SliderLayouts/types';
import type { LaneWrapperUser } from 'hb-builder/components/BuilderComponents/dynamic/Slider/SliderLayouts/UsersLaneWrapper/types';
import { APP_TYPE } from 'hb-react/types/appType';
import { completeName } from 'helpers/name';
import { partialLocation } from 'helpers/postalAddress';

const sublineFormatted = (
  subline: SublinesAttributes,
  user: LaneWrapperUser,
) => {
  const { display, type } = subline;
  const { cluster, last_location: lastLocation } = user;

  if (!display) {
    return;
  }

  if (type === 'location') {
    return partialLocation(lastLocation) || '';
  }

  if (type === 'cluster') {
    return cluster.join(', ');
  }

  if (!user[type]) {
    return;
  }

  return capitalize(user[type]);
};

export interface FormattedUser {
  id: number;
  link: string;
  picture: string;
  firstName: string;
  firstSubTitle?: string;
  secondSubTitle?: string;
  target: string;
}

export const mapUsers = ({
  app,
  users,
  dynamicAttributes,
}: {
  app: APP_TYPE;
  users: LaneWrapperUser[];
  dynamicAttributes?: SliderDynamicAttributes;
}): FormattedUser[] | undefined =>
  dynamicAttributes &&
  users?.map((user) => {
    const { id, photo: picture } = user;
    const href = app === APP_TYPE.BACKOFFICE ? '#' : Routes.user_path(id);
    const { firstSubline, secondSubline } = dynamicAttributes;

    return {
      id,
      link: href,
      picture,
      firstName: completeName(user),
      firstSubTitle: sublineFormatted(firstSubline, user),
      secondSubTitle: sublineFormatted(secondSubline, user),
      target: app === APP_TYPE.BACKOFFICE ? '' : '_blank',
    };
  });
